<template>
  <b-modal
    content-class="p-2 atm-rounded"
    v-model="_closeOrShow"
    size="m"
    title="You have unapproved task notifications."
    hide-header-close
    centered
    @ok="removeAll()"
  >
    <p class="d-flex w-100">
      ¿Are you sure to delete all current notifications?
    </p>
    <p class="d-flex w-100">
      If notifications are cleared, it will not be possible to recover them.
    </p>
    <template #modal-footer="{ ok, cancel }">
      <b-button size="sm" @click="cancel()">
        Cancel
      </b-button>
      <b-button size="sm" variant="danger" @click="ok()">
        Yes, I am sure
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    closeOrShow: {
      type: Boolean,
      default: false,
    },
    removeAll: {
      type: Function,
      default: () => {},
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    _closeOrShow: {
      get() {
        return this.closeOrShow;
      },
      set() {
        this.closeModal();
      },
    },
  },
};
</script>

